import * as React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export const UnmuteIcon: React.FC<SvgIconProps> = (props) => {
    return (
        <SvgIcon {...props} viewBox="0 0 24 24">
            <g>
                <path fill="currentColor" d="M11.5,4.692v14.622l-3.45-3.384L7.613,15.5H7H3c-0.271,0-0.5-0.229-0.5-0.5V9c0-0.271,0.229-0.5,0.5-0.5h4h0.612L8.05,8.072L11.5,4.692 M11.99,2.5c-0.243,0-0.49,0.089-0.691,0.288L7,7H3C1.897,7,1,7.907,1,9v6c0,1.093,0.897,2,2,2h4l4.29,4.209c0.203,0.201,0.453,0.291,0.698,0.291c0.516,0,1.012-0.399,1.012-0.999V3.498C13,2.9,12.505,2.5,11.99,2.5L11.99,2.5z"/>
            </g>
            <g>
                <path fill="currentColor" d="M17,14.75c-0.192,0-0.384-0.073-0.53-0.22c-0.293-0.293-0.293-0.768,0-1.061c0.201-0.204,0.78-0.915,0.78-1.47s-0.579-1.266-0.782-1.471c-0.29-0.294-0.289-0.769,0.004-1.06c0.293-0.291,0.766-0.292,1.059,0.001c0.125,0.125,1.22,1.256,1.22,2.53s-1.095,2.405-1.22,2.53C17.384,14.677,17.192,14.75,17,14.75z"/>
            </g>
            <g>
                <path fill="currentColor" d="M19.001,17.75c-0.241,0-0.479-0.117-0.623-0.333c-0.23-0.344-0.139-0.809,0.205-1.04c0.026-0.018,2.667-1.825,2.667-4.377s-2.641-4.359-2.667-4.377c-0.344-0.231-0.436-0.696-0.205-1.04c0.229-0.343,0.694-0.436,1.038-0.207C19.552,6.467,22.75,8.637,22.75,12s-3.198,5.533-3.334,5.624C19.288,17.709,19.144,17.75,19.001,17.75z"/>
            </g>
        </SvgIcon>
    );
};